// FIXME: These values are from Google Translate. We need the actual translation from Design team.
export var ErrorVerbiage = {
    Retriable: 'Pembayaran tidak dapat diproses. Sila semak maklumat kad anda dan cuba lagi.',
    NonRetriable: 'Pembayaran tidak dapat diproses. Sila masukkan kaedah pembayaran lain dan cuba lagi.',
    SystemError: 'Pembayaran tidak dapat diproses. Sila cuba lagi.'
};
